// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"381":"2b14791a","6291":"115785ff"}[chunkId] + ".chunk.css";
};